module.exports = __webpack_public_path__ + "media/dou.4589b423.mp3";